import { Grid, Stack, Typography } from "@mui/material";
import styled from "styled-components";
import muiStyled from "@mui/system/styled";

const TeamSection = () => {
  const teamMembers = [
    { name: "Priscilla Mannuel", role: "CEO", image: "" },
    { name: "Aniket Sharma", role: "CTO", image: "" },
    { name: "Arif B.", role: "Head of Operations", image: "" },
    { name: "Yohanes Yobel Y.", role: "Backend Engineer", image: "" },
    { name: "Hilarius Ryan A. B.", role: "Frontend Engineer", image: "" },
    { name: "Muhammad Zainuddin", role: "UI/UX", image: "" },
    { name: "Hafizh Zaki P. A.", role: "Data Scientist", image: "" },
    { name: "Bambang Adi P.", role: "System Analyst", image: "" }
  ];

  return (
    <SectionContainer id={"team-section"}>
      <ShapeContainer>
        <Container>
          <LeftTriangle />
          <CenterTrapezoid />
          <RightTriangle />
        </Container>
      </ShapeContainer>

      <TeamContainer>
        <Title>Our Team</Title>

        <SubTitleContainer container spacing={"36px"}>
          {teamMembers.map((member, index) => (
            <TeamMemberContainer
              size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
              key={index}
            >
              <ProfilePicture
                src={
                  member.image || "./assets/img/majura_template_profile_picture.webp"
                }
                alt={member.name}
              />

              <Stack direction={"column"} spacing={"24px"} alignItems={"center"}>
                <ProfileContainer>
                  <ProfileName>{member.name}</ProfileName>

                  <ProfileRole>{member.role}</ProfileRole>
                </ProfileContainer>
              </Stack>
            </TeamMemberContainer>
          ))}
        </SubTitleContainer>
      </TeamContainer>
    </SectionContainer>
  );
};

const SectionContainer = styled.section`
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
`;

const ShapeContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  transform: scaleX(-1);
`;

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 250px;

  @media (max-width: 767px) {
    // display: flex;
    // position: absolute;
    max-height: 100px;
  }
`;

const LeftTriangle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  clip-path: polygon(0% 0%, 81.2% 75%, 100% 100%, 0% 100%);
`;

const CenterTrapezoid = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #eff4ff;
  z-index: 1;
  clip-path: polygon(81.2% 75%, 100% 100%, 100% 100%, 0% 100%);
`;

const RightTriangle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  clip-path: polygon(81.2% 75%, 100% 69.8%, 100% 100%, 0% 100%);
`;

const TeamContainer = styled.div`
  background: #eff4ff;
  width: 100%;
  padding: 100px 0px 300px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
`;

const Title = muiStyled(Typography)(({ theme }) => ({
  color: "#002376",
  fontFamily: "Switzer",
  fontSize: "28px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "52px",
  letterSpacing: "1.372px",
  [theme.breakpoints.up("lg")]: {
    fontSize: "42px"
  }
}));

const SubTitleContainer = muiStyled(Grid)(({ theme }) => ({
  padding: "72px 32px",
  margin: "0 auto"
}));

const TeamMemberContainer = muiStyled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
}));

const ProfilePicture = styled.img`
  max-width: 200px;
  height: 100%;
  margin-bottom: 16px;
  object-fit: cover;
  border-radius: 180px;

  @media (max-width: 1025px) {
    max-width: 150px;
  }
`;

const ProfileContainer = styled.div`
    width: 100%,
    align-items: center,
    display: flex,
    justify-content: center,
    flex-direction: column
`;

const ProfileName = muiStyled(Typography)(({ theme }) => ({
  color: "#231F20",
  fontFamily: "Switzer",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: 500,
  textAlign: "center",
  [theme.breakpoints.up("md")]: {
    fontWeight: 700
  }
}));

const ProfileRole = muiStyled(Typography)(({ theme }) => ({
  color: "#58595B",
  fontFamily: "Switzer",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  textAlign: "center",
}));

export default TeamSection;
